import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface BulkActionBarProps {
  /** Number of selected rows. When 0, nothing renders. */
  count: number;
  onClear: () => void;
  /** Action buttons — typically styled with the .bulk-action-btn helper. */
  children: React.ReactNode;
  className?: string;
}

/**
 * Floating gradient toolbar that slides up from the bottom-center when rows
 * are selected — the design's bulk-action affordance.
 */
export function BulkActionBar({ count, onClear, children, className }: BulkActionBarProps) {
  if (count <= 0) return null;
  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 z-40 flex -translate-x-1/2 items-center gap-3 rounded-2xl bg-pulso-gradient py-2.5 pl-5 pr-3 text-white shadow-2xl",
        "animate-in slide-in-from-bottom-4 fade-in-0 duration-200",
        className,
      )}
    >
      <span className="text-sm font-bold">Zaznaczono: {count}</span>
      <span className="h-5 w-px bg-white/20" />
      {children}
      <button
        type="button"
        onClick={onClear}
        className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-white/70 transition-colors hover:bg-white/10 hover:text-white"
        title="Wyczyść"
        aria-label="Wyczyść zaznaczenie"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
